export default {
	state: {
		wareBackgroundColor: "#DCDCDC",
		stackColor: "#FFFFFF",
		stackSelectedColor: "#FFFF00",
		lockColor: "#F08080",
    haveColor: "#aaffff",
    haveSelectedColor: "#ffff7f",
	},

}



// WEBPACK FOOTER //
// ./src/store/modules/color.js